// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_DiscoverDuePaymentsResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /payroll/discover_due_payments
 *
 * Wire shape: `dados: { weekly: Bucket, biweekly: Bucket, monthly: Bucket }`.
 * All three keys are ALWAYS present (zeroed when the franchise has nothing due
 * at that frequency) so PayrollDashboard's `Object.entries(...).filter(
 * rules_count > 0)` never sees a missing key.
 *
 * History: the endpoint shipped in e865f45d returning raw rule arrays per
 * frequency, was dropped in 855715f5 / cb88c3f0 as collateral of unrelated
 * fixes, and the frontend kept calling it (404, swallowed) — the due-payments
 * grid was invisible from 2026-01-06 until this restore. It now returns the
 * aggregated shape the dashboard was written against.
 */
import type { Payroll_DuePaymentsBucketRow } from './Payroll_DuePaymentsBucketRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Payroll_DiscoverDuePaymentsResponseDados {
weekly?: Payroll_DuePaymentsBucketRow
biweekly?: Payroll_DuePaymentsBucketRow
monthly?: Payroll_DuePaymentsBucketRow
}

export type Payroll_DiscoverDuePaymentsResponse = ApiResponse<Payroll_DiscoverDuePaymentsResponseDados>;

registerResponseContract('Payroll_DiscoverDuePaymentsResponse', {
  weekly: {
    type: 'object',
    required: false,
    fields: {
      rules_count:     { type: 'number',  required: false },
      employees_count: { type: 'number',  required: false },
      overdue_count:   { type: 'number',  required: false },
      due_today_count: { type: 'number',  required: false },
      period_start:    { type: 'string',  required: false },
      period_end:      { type: 'string',  required: false },
      estimated_total: { type: 'string',  required: false },
    },
  },
  biweekly: {
    type: 'object',
    required: false,
    fields: {
      rules_count:     { type: 'number',  required: false },
      employees_count: { type: 'number',  required: false },
      overdue_count:   { type: 'number',  required: false },
      due_today_count: { type: 'number',  required: false },
      period_start:    { type: 'string',  required: false },
      period_end:      { type: 'string',  required: false },
      estimated_total: { type: 'string',  required: false },
    },
  },
  monthly: {
    type: 'object',
    required: false,
    fields: {
      rules_count:     { type: 'number',  required: false },
      employees_count: { type: 'number',  required: false },
      overdue_count:   { type: 'number',  required: false },
      due_today_count: { type: 'number',  required: false },
      period_start:    { type: 'string',  required: false },
      period_end:      { type: 'string',  required: false },
      estimated_total: { type: 'string',  required: false },
    },
  },
})
